import axios from '@/shared/axios';
import { BaseResponse } from '@/types/web.interface';

// 获取隐私协议勾选状态
export async function getReverseSearchAgreementApi() {
  const res = await axios.get<BaseResponse<any>>('/reverse-search/agreement');
  return res.data;
}

// 修改用户同意协议状态
export async function putReverseSearchAgreementApi(params: any) {
  const res = await axios.put<BaseResponse<any>>('/reverse-search/agreement', params);
  return res.data;
}

// 创建反向图片搜索任务
export async function postReverseSearchTaskApi(params: any) {
  const res = await axios.post<BaseResponse<any>>('/reverse-search/create', params);
  return res.data;
}

// 根据任务ID查询任务状态和详情
export async function getReverseSearchTaskByIdApi(taskId: number) {
  const res = await axios.get<BaseResponse<any>>(`/reverse-search/task/${taskId}`);
  return res.data;
}

// 查询用户的搜索任务列表
export async function getReverseSearchTaskListApi() {
  const res = await axios.get<BaseResponse<any>>('/reverse-search/premium-list');
  return res.data;
}

// 修改邮件通知状态
export async function putReverseSearchEmailNotifyApi(params: any) {
  const res = await axios.put<BaseResponse<any>>('/reverse-search/email-notify', params);
  return res.data;
}
